import { render, staticRenderFns } from "./SchoolSplitStudents.vue?vue&type=template&id=91fb15ac&scoped=true&"
import script from "./SchoolSplitStudents.vue?vue&type=script&lang=js&"
export * from "./SchoolSplitStudents.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSplitStudents.vue?vue&type=style&index=0&id=91fb15ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fb15ac",
  null
  
)

export default component.exports